import { cn } from 'src/helpers/style'
import i18n from 'src/i18n'

import {
  Button,
  Typography,
  TypographyVariant,
  TypographyWeight,
} from 'src/components/atoms'

import { TERMS_SECTIONS } from 'src/app/auth/domain/models/terms-content'

import { useTermsOfService } from './hooks/use-terms-of-service'

const headerClassName = cn(
  'sticky top-0 z-10 flex h-[81px] w-full shrink-0 items-center',
  'border-b border-border bg-surface-page px-12 lg:px-[120px]',
)

export const TermsOfServicePage = (): JSX.Element => {
  const {
    sentinelRef,
    hasScrolledToBottom,
    handleAccept,
    handleDecline,
    isSigningOut,
    isAccepting,
  } = useTermsOfService()

  return (
    <div className="min-h-screen bg-surface-page">
      <header className={headerClassName}>
        <Typography
          variant={TypographyVariant.titleSm}
          weight={TypographyWeight.regular}
          className="font-display text-brand-accent"
        >
          {i18n.t('brand.name')}
        </Typography>
      </header>

      <main className="mx-auto w-full max-w-[1440px] px-12 pb-20 pt-14 lg:px-[120px]">
        <div className="flex w-full max-w-[960px] flex-col gap-8">
          <div className="flex flex-col gap-2">
            <Typography
              variant={TypographyVariant.titleXl}
              weight={TypographyWeight.lighter}
              className="font-display text-content-primary"
            >
              {i18n.t('auth.termsPage.title')}
            </Typography>
            <Typography
              variant={TypographyVariant.bodyLg}
              className="text-content-secondary"
              weight={TypographyWeight.light}
            >
              {i18n.t('auth.termsPage.subtitle')}
            </Typography>
          </div>

          <Typography
            variant={TypographyVariant.bodyLg}
            className="text-content-secondary"
          >
            {i18n.t('auth.termsPage.effectiveDate')}
          </Typography>

          <div className="h-px w-full bg-border" aria-hidden />

          <div className="flex flex-col gap-6">
            {TERMS_SECTIONS.map(section => (
              <div key={section.id} className="flex flex-col gap-3">
                <Typography
                  variant={TypographyVariant.headingSm}
                  weight={TypographyWeight.light}
                  className="text-content-primary"
                >
                  {section.title}
                </Typography>
                <Typography
                  variant={TypographyVariant.bodyMd}
                  weight={TypographyWeight.regular}
                  className="text-content-primary"
                >
                  {section.body}
                </Typography>
              </div>
            ))}
          </div>

          <div ref={sentinelRef} aria-hidden className="h-px w-full" />

          <div className="h-px w-full bg-border" aria-hidden />

          <div className="flex flex-col items-stretch gap-4 sm:flex-row sm:items-center">
            <Button
              onClick={handleAccept}
              size="large"
              disabled={!hasScrolledToBottom || isSigningOut || isAccepting}
              label={i18n.t('auth.termsPage.accept')}
              className="justify-center"
            ></Button>

            <Button
              variant="secondary"
              size="large"
              onClick={handleDecline}
              disabled={isSigningOut || isAccepting}
              label={i18n.t('auth.termsPage.decline')}
              className="justify-center"
            ></Button>
          </div>
        </div>
      </main>
    </div>
  )
}
